import React, { useEffect, useState } from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const ModalReceivedGift = ({
  modalStatus,
  closeModal,
  gifts
}) => {

  const afterOpenModal = () => {};

  const selfClose = (event) => {
    event.preventDefault();
    closeModal();
  };


  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-received-gift"
    >
      <h2>
        <img src="/images/title-congrat.png" alt="" className="title-modal"/>
      </h2>
      <div className="modal-description">
        <div className="received-gift">
          <div className="received-gift__medal">
            {gifts[0]?.items.length > 0 && gifts[0].items.map((item, index) => {
              return (
                <div key={index}>
                  <img src={`/images/medal${item}.png`} alt="" />
                </div>
              )
            })}
          </div>

          <div>
            <img src="/images/equal.png" alt="" className="icon-equal"/>
          </div>

          <div className="received-gift__item">
            <img src={gifts[0]?.image} alt="" />
            <span>
              {gifts[0]?.reward_name}
            </span>
          </div>

          <div>
            <img src="/images/plus.png" alt="" className="icon-plus" />
          </div>

          <div className="point">
            {/* <img src="/images/star.png" alt="" /> */}
            <span>+{gifts[0]?.accumulation_point}</span>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalReceivedGift